import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { inject, onMounted, ref, watch,computed, type SetupContext} from "vue";
import type { CategoryDto } from "../../shared/CategoryDto.ts";
import type { CategoryService } from "../../application/services/CategoryService.ts";

interface Props {
  categoryId: number|null, // light/dark
}

export default {
  template: html,
  emits: {
      onCategorySelected: (value: number) => typeof value === "number"
  },
  props: {
    categoryId: {
      type: Number,
      required: false,
    },
  },
  setup(props:Props, { emit }: SetupContext) {
    const categories = ref<CategoryDto[]>([])
    const courseCategoryFilter = ref<number>(0);
    const error = ref<string>("");
    const categoryService: CategoryService|undefined = inject("categoryService")

    // computed properties
    const parentCategories = computed(function(){
      return categories.value.filter(function(item){
        return item.parentId == null;
      })
    })

    // methods
    const subCategoriesOf = function (parentId: number){
      return categories.value.filter(function(item){
        return item.parentId == parentId;
      })
    }

    const loadCategories = async function(){
      // UI muss alles kennen. Das ist im Prinzip der Server
      if (categoryService){
        try {
          categories.value = await categoryService.getAllCategories();
        } catch (err){
          error.value = String(err)
        }
      }
    }
    
    onMounted(async () => {
      await loadCategories();
      if (props.categoryId && props.categoryId > 0){
        courseCategoryFilter.value=props.categoryId
      }
    });
    
    watch(courseCategoryFilter, async () =>{
        emit("onCategorySelected", courseCategoryFilter.value)
    })
    
    return {
      error,
      courseCategoryFilter,
      parentCategories,
      subCategoriesOf,
    };
  },
};
